import { render, staticRenderFns } from "./ThankYouCanvas.vue?vue&type=template&id=00dc9937&"
import script from "./ThankYouCanvas.vue?vue&type=script&lang=js&"
export * from "./ThankYouCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports